module.exports = __webpack_public_path__ + "img/190-Gris Anthracite.jpg";